import { FORM_STATUS } from '@data-access';

export function mapHarvestProofStatusToFormStatus(
  status: string | null | undefined,
): FORM_STATUS | null {
  if (!status) {
    return null;
  }

  if (
    status === FORM_STATUS.FINISHED
    || status === 'PROOF_RECEIVED'
  ) {
    return FORM_STATUS.FINISHED;
  }

  if (
    status === FORM_STATUS.INCOMPLETE
    || status === 'PROOF_MISSING'
  ) {
    return FORM_STATUS.INCOMPLETE;
  }

  if (Object.values(FORM_STATUS).includes(status as FORM_STATUS)) {
    return status as FORM_STATUS;
  }

  return FORM_STATUS.UNDEFINED;
}
